import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';
import { MessageText, useMessageContext } from 'stream-chat-react';
import { Theme } from '@bizzabo/design-system';
import { isErrorMessage } from './Utils/MessageUtils';

const MessageTextContainer = () => {
    const classes = useStyles();
    const { handleOpenThread, message, threadList, initialMessage } = useMessageContext();
    const errorMessage = isErrorMessage(message);
    const isReplyMessageType = message.type === 'reply';

    const handleMessageClick = e => {
        if (!(e.target instanceof HTMLAnchorElement) && !isReplyMessageType) {
            handleOpenThread(e);
        }
    };

    return (
        <div className={classes.messageTextWrapper} onClick={handleMessageClick}>
            <MessageText
                customInnerClass={cn(classes.messageText, {
                    [classes.errorText]: errorMessage,
                    [classes.isReply]: isReplyMessageType,
                    [classes.firstMessageThread]: threadList && initialMessage,
                })}
            />
        </div>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        messageTextWrapper: {
            marginBottom: '2px',
            width: '100%',
        },
        messageText: {
            ...theme.typography.t71,
            cursor: 'pointer',
            wordBreak: 'break-word',
            color: theme.palette.greys[700],
            '& p': {
                margin: 0,
            },
            '& .str-chat__message-url-link': {
                color: theme.palette.greys[700],
                whiteSpace: 'normal',
            },
        },
        errorText: {
            color: theme.palette.primary[500],
            '& .str-chat__simple-message--error-message': {
                display: 'none',
            },
        },
        isReply: {
            cursor: 'default',
        },
        firstMessageThread: {
            cursor: 'default',
        },
    }),
    {
        classNamePrefix: 'MessageTextContainer',
    }
);

export default MessageTextContainer;
